import { useTranslation } from 'react-i18next';
import MainTitle from '../common/MainTitle';
import Icon from '../common/Icon';

export default function HeroSection({ buttonLink }) {
  const { t } = useTranslation(['CareersPage']);

  return (
    <section className="careers-hero-section">
      <div className="container">
        <div class="overlay"></div>
        <div className="careers-hero-section__content">
          <MainTitle type="light" className="text--2xl hidden--lg">
            <span>{t('heroTitle1')}</span>
            <span className="decorated-line decorated-line--light decorated-line--left">
              {t('heroTitle2')}
            </span>
            <span>{t('heroTitle3')}</span>
          </MainTitle>

          <div className="careers-hero-section__content-container">
            <MainTitle type="light" className="text--2xl hidden--md">
              <span>{t('heroTitle1')}</span>
              <span className="decorated-line decorated-line--light decorated-line--left">
                {t('heroTitle2')}
              </span>
              <span>{t('heroTitle3')}</span>
            </MainTitle>
          </div>
        </div>

        <a target="_blank" className="button action-button" href={buttonLink}>
          <Icon name="open-light" />
          <span>{t('heroAction')}</span>
        </a>
      </div>
    </section>
  );
}
